module["exports"] = ["Azərbaycan"];